import { render, staticRenderFns } from "./scenicMange.vue?vue&type=template&id=2c07dc28&scoped=true&"
import script from "./scenicMange.vue?vue&type=script&lang=js&"
export * from "./scenicMange.vue?vue&type=script&lang=js&"
import style0 from "./scenicMange.vue?vue&type=style&index=0&id=2c07dc28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07dc28",
  null
  
)

export default component.exports